import { recipe } from "@vanilla-extract/recipes";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../theme/css/theme.css";
import { avatarStyle } from "../Avatar/Avatar.css";

export const badgeStyle = recipe({
  base: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "999px",
    userSelect: "none",
    lineHeight: 1,
    fontWeight: 700,
  },
  variants: {
    variant: {
      background: {
        backgroundColor: theme.colors.background,
        color: theme.colors.onBackground,
      },
      primary: {
        backgroundColor: theme.colors.primary,
        color: theme.colors.onPrimary,
      },
      secondary: {
        backgroundColor: theme.colors.secondary,
        color: theme.colors.onSecondary,
      },
      gradient: {
        background: `linear-gradient(110deg, ${theme.colors.gradientA} -5%, ${theme.colors.gradientB} 50%, ${theme.colors.gradientC} 105%)`,
        color: theme.colors.onPrimary,
      },
      /**
       * @deprecated
       */
      tertiary: {
        backgroundColor: theme.colors.tertiary,
        color: theme.colors.onTertiary,
      },
      info: {
        backgroundColor: theme.colors.info,
        color: theme.colors.onInfo,
      },
      infoSurface: {
        backgroundColor: theme.colors.infoSurface,
        color: theme.colors.onInfoSurface,
      },
      success: {
        backgroundColor: theme.colors.success,
        color: theme.colors.onSuccess,
      },
      successSurface: {
        backgroundColor: theme.colors.successSurface,
        color: theme.colors.onSuccessSurface,
      },
      error: {
        backgroundColor: theme.colors.error,
        color: theme.colors.onError,
      },
      errorSurface: {
        backgroundColor: theme.colors.errorSurface,
        color: theme.colors.onErrorSurface,
      },
      warning: {
        backgroundColor: theme.colors.warning,
        color: theme.colors.onWarning,
      },
      warningSurface: {
        backgroundColor: theme.colors.warningSurface,
        color: theme.colors.onWarningSurface,
      },
      accent: {
        backgroundColor: theme.colors.primary,
        color: theme.colors.onPrimary,
      },
    },
    inline: {
      true: {
        position: "relative",
      },
      false: {
        position: "absolute",
        selectors: {
          [`${avatarStyle} &`]: {
            zIndex: 1,
          },
        },
      },
    },
    offset: {
      default: {
        top: 0,
        right: 0,
      },
      small: {
        top: 0,
        right: 0,
        transform: "translate(20%, -20%)",
      },
      smallTop: {
        top: 0,
        right: 0,
        transform: "translate(0, -20%)",
      },
      medium: {
        top: 0,
        right: 0,
        transform: `translate(30%, -30%)`,
      },
      mediumTop: {
        top: 0,
        right: 0,
        transform: `translate(0, -30%)`,
      },
      large: {
        top: 0,
        right: 0,
        transform: `translate(${rem(10)}, -50%)`,
      },
      largeTop: {
        top: 0,
        right: 0,
        transform: `translate(0, -50%)`,
      },
    },
    icon: {
      true: {
        // padding: `0 ${rem(6)}`,
      },
      false: {
        padding: `0 ${rem(4)}`,
      },
    },
    isString: {
      true: {
        padding: `0 ${rem(8)}`,
      },
      false: {},
    },
    size: {
      xxxs: {
        fontSize: rem(6),
        height: rem(12),
        minWidth: rem(12),
      },
      xxs: {
        fontSize: rem(8),
        height: rem(16),
        minWidth: rem(16),
      },
      xs: {
        fontSize: rem(10),
        height: rem(18),
        minWidth: rem(18),
      },
      s: {
        fontSize: rem(12),
        height: rem(22),
        minWidth: rem(22),
      },
      m: {
        fontSize: rem(16),
        height: rem(28),
        minWidth: rem(28),
      },
      l: {
        fontSize: rem(20),
        height: rem(36),
        minWidth: rem(36),
      },
    },
  },
  defaultVariants: {
    variant: "primary",
    size: "xs",
  },
});
